import store from './index';
export const selectEmirates = () => store((state) => state.emirates);
export const selectFetchedEmirate = () => store((state) => state.emirate);
export const selectSelectedEmirate = () => store((state) => state.selected);
export default {
    setSelected: store.getState().setSelected,
    addEmirate: store.getState().addEmirate,
    getEmirates: store.getState().getEmirates,
    getEmirate: store.getState().getEmirate,
    createEmirate: store.getState().createEmirate,
    editEmirate: store.getState().editEmirate,
    deleteEmirate: store.getState().deleteEmirate,
};
